import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  makeStyles,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';

const useStyles = makeStyles(() => ({
  root: { backgroundColor: 'White' },
  avatar: {
    width: 60,
    height: 60,
  },
}));

const TopBar = ({ className, onMobileNavOpen, ...rest }) => {
  const modalOpen = localStorage.getItem('modalOpen') || false;
  const isModalOpen = JSON.parse(modalOpen) || false;
  const classes = useStyles();
  return (
    <AppBar
      className={clsx(classes.root, className)}
      elevation={0}
      {...rest}
      style={{ zIndex: isModalOpen ? 0 : 1 }}
    >
      <Toolbar>
        <IconButton
          color='inherit'
          onClick={() => {
            console.log('click event');
            onMobileNavOpen();
          }}
        >
          <MenuIcon style={{ color: '#C98B76' }} />
        </IconButton>
        <Box flexGrow={1} />
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
};

export default TopBar;
